import React from "react"

const FullScreenLoader = () => {

    return (<div id="cover-spin"></div>)
}

export default FullScreenLoader
